<template>
  <div>
    <div class="sourceMain">
      <b-row class="sourceMainSections">
        <b-col sm="2" class="sectionsFilters">
          <b-col class="filters">
            <p>Filtros</p>
          </b-col>
          <b-col class="section1">
            <b-row>
              <b-col sm="12">
                <span class="filtersTitle">Fonte</span>
              </b-col>
              <b-col>
                <v-select
                  v-model="sourceId"
                  :options="optionsSource"
                  class="filtersSelect"
                  label="source"
                  :reduce="(source) => source.id"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12">
                <span class="filtersTitle">Estado</span>
              </b-col>
              <b-col>
                <v-select
                  v-model="selectedStatus"
                  :options="optionStatus"
                  class="filtersSelect"
                  label="status"
                  :reduce="(status) => status.code"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12">
                <span class="filtersTitle">Severidade</span>
              </b-col>
              <b-col>
                <v-select
                  v-model="selectedSeverity"
                  :options="optionsSeverity"
                  class="filtersSelect"
                  label="type"
                  :reduce="(type) => type.id"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12">
                <span class="filtersTitle">Execução</span>
              </b-col>
              <b-col>
                <v-select
                  v-model="selectedExecution"
                  :options="optionExecution"
                  class="filtersSelect"
                  label="type"
                  :reduce="(type) => type.id"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12">
                <span class="filtersTitle">Data de Inicio</span>
              </b-col>
              <b-col>
                <b-form-input
                  v-model="startDateOfLog"
                  type="date"
                  size="sm"
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12">
                <span class="filtersTitle">Data de Fim</span>
              </b-col>
              <b-col>
                <b-form-input
                  v-model="endDateLog"
                  type="date"
                  size="sm"
                ></b-form-input>
              </b-col>
            </b-row>
            <b-col class="filterButton">
              <b-button class="btnFilterClear" @click="clearFilters()"
                >Limpar</b-button
              >
            </b-col>
            <b-col class="filterButton">
              <b-button class="btnFilter" @click="filterLogInfo()"
                >Pesquisar</b-button
              >
            </b-col>
          </b-col>
        </b-col>
        <b-col sm="5" class="sectionOperation">
          <b-col class="section1Title">
            <b-row>
              <b-col style="text-align: left">Operation Logs</b-col>
            </b-row>
          </b-col>
          <b-col
            class="section2"
            id="section2"
            v-on:scroll.passive="handleScrolll"
          >
            <b-col
              class="section2Source"
              v-for="log in filteredLogs"
              @click="openSection3(log.c_id)"
              :key="log.c_id"
            >
              <b-row v-if="log.c_u_Status == 1" class="section2Log">
                <b-col class="section2LogText">
                  <h6>
                    {{ new Date(log.c_u_Date).getDate() }}/{{
                      new Date(log.c_u_Date).getMonth() + 1
                    }}/{{ new Date(log.c_u_Date).getFullYear() }} às
                    {{
                      new Date(log.c_u_Date).getHours() < 10
                        ? "0" + new Date(log.c_u_Date).getHours()
                        : new Date(log.c_u_Date).getHours()
                    }}:{{
                      new Date(log.c_u_Date).getMinutes() < 10
                        ? "0" + new Date(log.c_u_Date).getMinutes()
                        : new Date(log.c_u_Date).getMinutes()
                    }}
                    <span style="font-weight: bold">Resultado:</span>
                    {{ log.c_u_Result }}
                  </h6>
                </b-col>
              </b-row>
              <b-row v-if="log.c_u_Status == -1" class="section2Error">
                <b-col class="section2LogText">
                  <h6>
                    {{ new Date(log.c_u_Date).getDate() }}/{{
                      new Date(log.c_u_Date).getMonth() + 1
                    }}/{{ new Date(log.c_u_Date).getFullYear() }} às
                    {{
                      new Date(log.c_u_Date).getHours() < 10
                        ? "0" + new Date(log.c_u_Date).getHours()
                        : new Date(log.c_u_Date).getHours()
                    }}:{{
                      new Date(log.c_u_Date).getMinutes() < 10
                        ? "0" + new Date(log.c_u_Date).getMinutes()
                        : new Date(log.c_u_Date).getMinutes()
                    }}
                    <span style="font-weight: bold">Resultado:</span>
                    {{ log.c_u_Result }}
                  </h6>
                </b-col>
              </b-row>
            </b-col>
          </b-col>
        </b-col>
        <!-- Details of Operation Log -->
        <b-col v-if="section3" sm="5" class="section3">
          <b-col class="section3Reference">
            <p>Detalhes</p>
          </b-col>
          <b-col>
            <b-row class="my-1" v-if="clickedLogs.c_r_Source != null">
              <b-col sm="2" class="labelLog">
                <label>Ref Fonte</label>
              </b-col>
              <b-col sm="10" class="referenceName">{{
                lo.find(this.sourcesArray, function (src) {
                  return src.c_id == clickedLogs.c_r_Source;
                }).c_u_ReferenceSource
              }}</b-col>
            </b-row>
          </b-col>
          <b-col>
            <b-row class="my-1">
              <b-col sm="2" class="labelLog">
                <label>Severidade</label>
              </b-col>
              <b-col sm="10" class="referenceName">{{
                lo.filter(optionsSeverity, function (log) {
                  return log.id == clickedLogs.c_u_Severity;
                })[0].type
              }}</b-col>
            </b-row>
          </b-col>
          <b-col>
            <b-row class="my-1">
              <b-col sm="2" class="labelLog">
                <label>Execução</label>
              </b-col>
              <b-col sm="10" class="referenceName">{{
                executionType != []
                  ? executionType.c_u_Type == 1
                    ? "Get Execution"
                    : "Extract Execution"
                  : "-"
              }}</b-col>
            </b-row>
          </b-col>
          <b-col>
            <b-row class="my-1">
              <b-col sm="2" class="labelLog">
                <label>Estado</label>
              </b-col>
              <b-col
                sm="10"
                class="referenceName"
                v-if="clickedLogs.c_u_Status == 1"
                >Sucesso</b-col
              >
              <b-col
                sm="10"
                class="referenceName"
                v-if="clickedLogs.c_u_Status == -1"
                >Erro</b-col
              >
            </b-row>
          </b-col>
          <b-col>
            <b-row class="my-1">
              <b-col sm="2" class="labelLog">
                <label>Tipo ID</label>
              </b-col>
              <b-col sm="10" class="referenceName">{{
                clickedLogs.c_u_EventTypeID
              }}</b-col>
            </b-row>
          </b-col>
          <b-col>
            <b-row class="my-1">
              <b-col sm="2" class="labelLog">
                <label>Data</label>
              </b-col>
              <b-col sm="10" class="referenceName"
                >{{ new Date(clickedLogs.c_u_Date).getFullYear() }}/{{
                  new Date(clickedLogs.c_u_Date).getMonth()
                }}/{{ new Date(clickedLogs.c_u_Date).getDate() }}
                {{ new Date(clickedLogs.c_u_Date).getHours() }}:{{
                  new Date(clickedLogs.c_u_Date).getMinutes()
                }}:{{ new Date(clickedLogs.c_u_Date).getSeconds() }}</b-col
              >
            </b-row>
          </b-col>
          <b-col>
            <b-row class="my-1">
              <b-col sm="2" class="labelLog">
                <label>Descriçao</label>
              </b-col>
              <b-col sm="10" class="referenceName">{{
                clickedLogs.c_u_Description
              }}</b-col>
            </b-row>
          </b-col>
          <b-col>
            <b-row>
              <b-col sm="2" class="labelLog">
                <label>Resultado</label>
              </b-col>
              <b-col sm="10" class="referenceName">{{
                clickedLogs.c_u_Result
              }}</b-col>
            </b-row>
          </b-col>
        </b-col>
      </b-row>
    </div>
    <!-- <div class="container-fluid" style="margin-top:20px;">
        <b-table striped hover :items="logs" :per-page="5" :currentPage="currentPage" :fields="fields" small fixed caption-top outlined>
        </b-table>
      </div>
      <div class="mt-3">
			  <b-pagination :total-rows="totalItems" :per-page="5" align="center" v-model="currentPage"></b-pagination>
    </div>-->
  </div>
</template>

<script>
import vSelect from "vue-select";
import Vue from "vue";
import "vue-select/dist/vue-select.css";
import $ from "jquery";

export default {
  data() {
    return {
      logs: [],
      endpoint: "OperationLogs",
      endpointExecution: "Executions",
      totalItems: 0,
      currentPage: 1,
      filteredLogs: [],
      clickedLogs: [],
      section3: false,
      lo: _,
      optionsType: [
        { id: 0, type: "undefined" },
        { id: 1, type: "Get news from a source for a manual scheduling" },
        { id: 2, type: "Get selected news for a manual scheduling" },
        { id: 3, type: "Get news from sources for an automatic scheduling" },
        { id: 4, type: "Get news with no previous response" },
        { id: 5, type: "Extract information from news" },
      ],
      optionsSeverity: [
        { id: 2, type: "Information" },
        { id: 3, type: "Warning" },
        { id: 4, type: "Error" },
        { id: 5, type: "Critical" },
      ],
      optionStatus: [
        { code: -1, status: "Erro" },
        { code: 1, status: "Sucesso" },
      ],
      optionExecution: [
        { id: 1, type: "Get Execution" },
        { id: 2, type: "Extract Execution" },
      ],
      selectedStatus: [],
      selectedSeverity: [],
      selectedExecution: [],
      optionsSource: [],
      executionType: [],
      sourceId: [],
      startDateOfLog: "",
      endDateLog: "",
      sourcesArray: [],
      fields: [
        {
          key: "c_u_Status",
          label: "Status",
          formatter: (value, key, item) => {
            if (value == 1) {
              item["_rowVariant"] = "success";
              return (value = "Success");
            }
            if (value == -1) {
              item["_rowVariant"] = "danger";
              return (value = "Error");
            }
          },
        },
        {
          key: "c_u_Date",
          label: "Date",
        },
        {
          key: "c_u_Source",
          label: "Source",
          formatter: (value, key, item) => {
            return item.sources.c_u_ReferenceSource;
          },
        },
        {
          key: "c_u_Description",
          label: "Description",
        },
        {
          key: "c_u_Result",
          label: "Result",
        },
      ],
    };
  },
  components: {
    vSelect,
  },

  methods: {
    async getLogs() {
      this.$api.data.endpoint = "Sources";
      this.sourcesArray = await this.$api.data.find();

      this.$api.data.endpoint = this.endpoint;
      this.logs = await this.$api.data.find();
      this.filteredLogs = _.orderBy(this.logs, ["c_u_Date"], ["desc"]);

      for (let index = 0; index < this.sourcesArray.length; index++) {
        Vue.set(this.optionsSource, index, {
          id: this.sourcesArray[index].c_id,
          source: this.sourcesArray[index].c_u_ReferenceSource,
        });
      }
      this.totalItems = this.logs.length;
    },
    async openSection3(id) {
      this.$api.data.endpoint = this.endpoint;
      this.clickedLogs = await this.$api.data.findOneById(id);
      this.$api.data.endpoint = this.endpointExecution;
      this.executionType = await this.$api.data.findOneById(
        this.clickedLogs.c_r_Execution
      );

      this.section3 = true;
    },
    async filterLogInfo() {
      let filter = [];
      this.sourceId = this.sourceId > 0 ? this.sourceId : 0;
      this.selectedStatus =
        typeof this.selectedStatus == "number" ? this.selectedStatus : 0;
      this.startDateOfLog =
        this.startDateOfLog != "" ? this.startDateOfLog : "0";
      this.endDateLog = this.endDateLog != "" ? this.endDateLog : "0";
      this.selectedExecution =
        typeof this.selectedExecution == "number" ? this.selectedExecution : 0;
      this.selectedSeverity =
        typeof this.selectedSeverity == "number" ? this.selectedSeverity : "";
      if (
        this.sourceId != 0 ||
        this.selectedStatus != 0 ||
        this.startDateOfLog != "0" ||
        this.endDateLog != "0" ||
        this.selectedExecution != 0 ||
        this.selectedSeverity != ""
      ) {
        this.$api.data.endpoint = `OperationLogs/scrollByFilter/0/${
          this.sourceId
        }/${this.selectedStatus}/${
          this.selectedSeverity != "" ? this.selectedSeverity : -2
        }/${this.selectedExecution}/${this.startDateOfLog}/${this.endDateLog}`;
        filter = await this.$api.data.find();
        this.filteredLogs = _.orderBy(filter, ["c_u_Date"], ["desc"]);
      } else {
        this.getLogs();
      }
    },
    clearFilters() {
      (this.selectedStatus = []),
        (this.selectedSeverity = []),
        (this.selectedExecution = []),
        (this.optionsSource = []),
        (this.sourceId = []),
        (this.startDateOfLog = ""),
        (this.endDateLog = ""),
        this.getLogs();
    },
    handleScrolll() {
      if (!this.$api.data.endpoint.match("scrollByFilter")) {
        let itsFinal = 0;
        let that = this;
        let newDataOfLogs = [];
        $("#section2").on("scroll", async function () {
          var scrollPosition = Math.round(
            $(this).scrollTop() + $(this).innerHeight(),
            10
          );
          var divTotalHeight =
            $(this)[0].scrollHeight +
            parseInt($(this).css("padding-top"), 10) +
            parseInt($(this).css("padding-bottom"), 10) +
            parseInt($(this).css("border-top-width"), 10) +
            parseInt($(this).css("border-bottom-width"), 10);

          if (scrollPosition >= divTotalHeight && itsFinal == 0) {
            that.$api.data.endpoint = `OperationLogs/scrollDown/${that.filteredLogs.length}`;
            newDataOfLogs = await that.$api.data.find();
            for (let index = 0; index < newDataOfLogs.length; index++) {
              if (that.filteredLogs.indexOf(newDataOfLogs[index]) == -1) {
                that.filteredLogs.push(newDataOfLogs[index]);
              }
            }
            that.filteredLogs = _.uniq(that.filteredLogs);
          }
          itsFinal++;
        });
      }
      if (this.$api.data.endpoint.match("scrollByFilter")) {
        let itsFinal = 0;
        let that = this;
        let newDataOfLogs = [];
        $("#section2").on("scroll", async function () {
          var scrollPosition = Math.round(
            $(this).scrollTop() + $(this).innerHeight(),
            10
          );
          var divTotalHeight =
            $(this)[0].scrollHeight +
            parseInt($(this).css("padding-top"), 10) +
            parseInt($(this).css("padding-bottom"), 10) +
            parseInt($(this).css("border-top-width"), 10) +
            parseInt($(this).css("border-bottom-width"), 10);

          if (scrollPosition >= divTotalHeight && itsFinal == 0) {
            that.$api.data.endpoint = `OperationLogs/scrollByFilter/${
              that.filteredLogs.length
            }/${that.sourceId}/${that.selectedStatus}/${
              typeof that.selectedSeverity == "number"
                ? that.selectedSeverity
                : -2
            }/${
              typeof that.selectedExecution == "number"
                ? that.selectedExecution
                : 0
            }/${that.startDateOfLog}/${that.endDateLog}`;
            newDataOfLogs = await that.$api.data.find();
            for (let index = 0; index < newDataOfLogs.length; index++) {
              if (that.filteredLogs.indexOf(newDataOfLogs[index]) == -1) {
                that.filteredLogs.push(newDataOfLogs[index]);
              }
            }
            that.filteredLogs = _.uniq(that.filteredLogs);
          }
          itsFinal++;
        });
      }
    },
  },
  computed: {},

  async mounted() {
    this.getLogs();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
.sourceMain {
  overflow: hidden;
  height: calc(100vh - 100px);
}

.sourceMainSections {
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
  height: 100%;
}

.sectionsFilters {
  margin-top: 10px;
  display: block;
  max-height: 100%;
  height: 100%;
}

.sectionOperation {
  display: block;
  max-height: 100%;
  height: 100%;
}

.section1 {
  margin-top: 10px;
  background-color: rgb(242, 242, 242);
  height: 100%;
}

.filters {
  background-color: rgb(66, 139, 172);
  color: white;
  font-weight: bold;
  text-align: center;
  padding: 10px;
  height: 50px;
}

.filtersTitle {
  float: left;
  color: rgb(66, 139, 172);
  font-weight: bold;
  font-size: 12px;
}

.filtersSelect {
  background-color: white;
}
.checkBox {
  margin-top: 5px;
}

.filtersCheckBox {
  color: rgb(66, 139, 172);
  font-weight: bold;
  font-size: 12px;
}

.filterButton {
  margin-top: 20px;
}
.btnFilter {
  background-color: rgb(66, 139, 172);
  color: white;
  font-weight: bold;
}

.btnFilterClear {
  background-color: white;
  color: black;
  font-weight: bold;
}
.section1Title {
  background-color: rgb(66, 139, 172);
  color: white;
  font-weight: bold;
  text-align: center;
  padding: 10px;
  height: 50px;
  margin-top: 10px;
}

.createDiv {
  text-align: right;
}

.createBtn {
  border-radius: 20px;
  background-color: rgb(231, 242, 245);
  color: rgb(66, 139, 172);
  padding: 0.275rem 0.55rem;
}

.section2 {
  background-color: rgb(242, 242, 242);
  overflow-y: scroll;
  height: 100%;
}

.section2Source {
  border: 2px solid rgb(242, 242, 242);
  margin: 5px;
}

.section2Source:hover {
  box-shadow: 0 0 11px rgba(33, 33, 33, 0.2);
}

.section2Log {
  background-color: rgb(202, 229, 205);
  color: black;
  font-weight: bold;
  font-size: 12px;
  text-align: left;
  margin: 5px;
}
.section2LogText {
  word-wrap: break-word;
}

.section2LogText h6 {
  font-size: 13px;
  padding: 5px;
  margin: 0;
}

.section2Error {
  background-color: rgb(231, 179, 184);
  color: black;
  font-weight: bold;
  font-size: 12px;
  text-align: left;
  margin: 5px;
}

.section3 {
  font-size: 13px;
}

.section3Reference {
  background-color: rgb(24, 65, 77);
  color: white;
  font-weight: bold;
  text-align: center;
  padding: 10px;
  height: 50px;
  margin-top: 10px;
  font-size: 1rem;
}
.section3Title {
  background-color: rgb(66, 139, 172);
  color: white;
  font-weight: bold;
  text-align: left;
  border-radius: 10px;
  padding: 10px;
  height: 50px;
  margin-top: 10px;
}
.labelLog {
  background-color: rgb(66, 139, 172);
  color: white;
  font-weight: bold;
  text-align: left;
  border-radius: 10px;
  margin-top: 10px;
}

.referenceName {
  background-color: rgb(242, 242, 242);
  text-align: left;
  border-radius: 10px;
  margin-top: 10px;
}

.editXML button {
  background-color: rgb(66, 139, 172);
  color: white;
  margin-top: 10px;
  font-weight: bold;
}

.createXML button {
  background-color: rgb(66, 139, 172);
  color: white;
  margin-top: 10px;
  font-weight: bold;
}

.section3Footer button {
  background-color: rgb(77, 150, 132);
}
</style>



// WEBPACK FOOTER //
// src/components/OperationLog/OperationLog.vue